export const formatStatusValue = (val) => {
    if (val === '-') {
      return val
    }

    const splitValue = val.split(' ');
    return `${Number(splitValue[0]) === 0 ? '0' : Number(splitValue[0]).toFixed(2)} ${splitValue[1]}`;
  }